import React, { useEffect, useState, useCallback } from 'react'
import { CSmartTable, CAccordionBody } from '@coreui/react-pro'
import UserService from 'src/service/UserService'

const MctGameAccord5 = ({ isOpen }) => {
  const [loading, setLoading] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState({})
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState()
  const columns = [
    { label: 'Game ID', key: 'id' },
    { key: 'game_name', label: 'Game Name' },
    { label: 'Hub Name', key: 'hub_name' },
    { label: 'Hub ID', key: 'hub_id' },
    { label: 'Bonus Card', key: 'is_bonus_card_activate' },
    { label: 'Team of Round', key: 'is_totr_activate' },
    { label: 'Bracket Battle', key: 'is_bracket_battle_activate' },
    { label: 'Head-to-head', key: 'is_h2h_activate' },
    { label: 'Votes', key: 'is_voting_activate' },
  ]

  // Wrap fetchGameData in useCallback to manage dependencies

  const fetchGameDataForAccord5 = useCallback(async () => {
    setLoading(true)
    try {
      const offset = (activePage - 1) * itemsPerPage
      const params = new URLSearchParams()
      Object.keys(columnFilter).forEach((key) => params.append(key, columnFilter[key]))
      if (columnSorter?.column)
        params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

      const result = await UserService.getMctGameAccord5Listing(
        offset,
        itemsPerPage,
        activePage,
        params,
      )
      setUsers(result.data)
    } catch (error) {
      console.error('Error fetching game data:', error)
    } finally {
      setLoading(false)
    }
  }, [activePage, columnFilter, columnSorter, itemsPerPage]) // Add dependencies for re-running

  useEffect(() => {
    if (isOpen) {
      console.log('from useEffect')
      fetchGameDataForAccord5()
    }
  }, [isOpen, fetchGameDataForAccord5])

  return (
    <>
      <CAccordionBody>
        <CSmartTable
          columns={columns}
          columnFilter={{ external: true }}
          columnSorter={{ external: true }}
          scopedColumns={{
            team_view: (item) => <td> {item?.is_bonus_card_activate === 1 ? 'Yes' : 'No'}</td>,
            is_totr_activate: (item) => <td> {item?.is_totr_activate === 1 ? 'Yes' : 'No'}</td>,
            is_bracket_battle_activate: (item) => (
              <td> {item?.is_bracket_battle_activate === 1 ? 'Yes' : 'No'}</td>
            ),
            is_h2h_activate: (item) => <td> {item?.is_h2h_activate === 1 ? 'Yes' : 'No'}</td>,
            is_voting_activate: (item) => <td> {item?.is_voting_activate === 1 ? 'Yes' : 'No'}</td>,
          }}
          items={users?.data}
          itemsPerPage={itemsPerPage}
          itemsPerPageSelect
          loading={loading}
          pagination={{ external: true }}
          paginationProps={{
            activePage,
            pages: Math.ceil(users?.total / itemsPerPage) || 1,
          }}
          tableProps={{ hover: true, responsive: true }}
          onActivePageChange={setActivePage}
          onColumnFilterChange={(filter) => {
            setActivePage(1)
            setColumnFilter(filter)
          }}
          onItemsPerPageChange={(itemsPerPage) => {
            setActivePage(1)
            setItemsPerPage(itemsPerPage)
          }}
          onSorterChange={setColumnSorter}
        />
      </CAccordionBody>
    </>
  )
}

export default MctGameAccord5
